module.exports = __webpack_public_path__ + "static/media/emptyChart.9f8c11c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/dashboardPage/inventoryCheckCard/emptyChart.png
// module id = 723
// module chunks = 0